import { dateFnsLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { format, parse, startOfWeek, getDay } from 'date-fns';
import { ptBR } from 'date-fns/locale';


export const sxToolbar = {
  padding: '1px 10px',
  border: '2px solid #C0D907',
  transition: 'background-color 0.3s ease',
  '&:hover': {
    backgroundColor: '#141259',
    transform: 'scale(1.09)',// Ajuste a cor de hover conforme necessário
  },
  '&:active, &:focus': {
    backgroundColor: '#141259', // Mantém a cor original no estado ativo
  },
}

export const sxToolbarFormatos = {
  padding: '1px 10px',
  border: '2px solid #C0D907',
  transition: 'background-color 0.3s ease',
  backgroundColor: '#141259',
  borderRadius: '5px',
  color: '#FFFFFF', 
  marginRight: '5px',
  '&:hover': {
    backgroundColor: '#141259',
    transform: 'scale(1.09)',// Ajuste a cor de hover conforme necessário
  },
  '&:active, &:focus': {
    backgroundColor: '#141259', // Mantém a cor original no estado ativo
  },
}

export const sxToolbarFormatosMobile = {
  padding: '1px 10px',
  marginTop: '5px',
  border: '2px solid #C0D907',
  transition: 'background-color 0.3s ease',
  '&:hover': {
    backgroundColor: '#141259',
    transform: 'scale(1.09)',// Ajuste a cor de hover conforme necessário
  },
  '&:active, &:focus': {
    backgroundColor: '#141259', // Mantém a cor original no estado ativo
  },
}

export const sxButton = {
  backgroundColor: '#141259',
  textTransform: 'none',
  border: '3px solid #141259',
  color: '#FFFFFF',
  transition: 'background-color 0.3s ease',
  borderRadius: '5px',
  '&:hover': {
    backgroundColor: '#141259',
    transform: 'scale(1.09)',// Ajuste a cor de hover conforme necessário
  },
  '&:active': {
    backgroundColor: '#141259', // Mantém a cor original no estado ativo
  },
  '&:focus': {
    backgroundColor: '#141259', // Mantém a cor original no estado de foco
  }
}

export const sxPrimaryColor = { backgroundColor: "#C0D907", border: "2px solid #141259", color: '#141259'}

export const sxDangerColor = { backgroundColor: "#FF5C4F", border: "2px solid #141259", color: '#141259' }

export const sxWarningColor = { backgroundColor: "#FFCC4F", border: "2px solid #141259", color: '#141259' }


export const locales = {'pt-BR': ptBR };

export const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek: () => startOfWeek(new Date(), { locale: ptBR }),
  getDay,
  locales,
});

export const formats = {
  weekdayFormat: (date, culture, localizer) =>
    localizer.format(date, "EEEEEE", culture),
};

export const messages = {
  next: 'Próximo',
  previous: 'Anterior',
  today: 'Hoje',
  month: 'Mês',
  week: 'Semana',
  day: 'Dia'
};